import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';
import { addMessage } from 'store/messages/actions';
import { setWallMetaData } from 'store/wallsMetaData/actions';
import { configurationChanged } from 'store/configurationChange/actions';

import wallFieldsFilled from '../../../services/wallFieldsFilled';

const EditWallButton = ({
  closeRightBar,
  selectedWall,
}: {
  closeRightBar: () => void;
  selectedWall: any;
}): JSX.Element => {
  const dispatch = useDispatch();
  const wall = useSelector((state: any) => state.selectedWall.properties);
  const wallMetaData = useSelector((state: any) => state.selectedWall.metaData);

  const { t } = useTranslation([translations.common]);

  const editWall = () => {
    if (!selectedWall) {
      dispatch(
        addMessage(t(`${translations.common}:Modal Messages.Starting Point`))
      );

      return;
    }

    if (!wallFieldsFilled(wall)) {
      dispatch(
        addMessage(t(`${translations.common}:Modal Messages.Fill All Fields`))
      );

      return;
    }

    dispatch(setWallMetaData(wallMetaData));
    dispatch(configurationChanged());

    window.EditWallLineAndConnection({
      ...wall,
      positionOffset: -wall.positionOffset,
    });

    closeRightBar();
  };

  return (
    <PrimaryButton onClick={editWall} className="action-button">
      {t(`${translations.common}:Wall Actions.Edit Wall`).toLocaleUpperCase()}
    </PrimaryButton>
  );
};

export default EditWallButton;
